export function exitFullScreen(element?: Element) {
  // Polyfill for IOS
  if (element.webkitDisplayingFullscreen) {
    return element.webkitExitFullScreen();
  }

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

export function requestFullscreen(element?: Element) {
  if (element.webkitDisplayingFullscreen === false) {
    return element.webkitEnterFullscreen();
  }

  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

export function isFullScreen() {
  return !(
    !document.fullscreenElement &&
    !document.webkitIsFullScreen &&
    !document.mozFullScreen &&
    !document.msFullscreenElement
  );
}

export function fullScreen(element?: Element) {
  // Polyfill for IOS
  if (element.webkitDisplayingFullscreen === false) {
    return element.webkitEnterFullscreen();
  } else if (element.webkitDisplayingFullscreen) {
    return element.webkitExitFullScreen();
  }

  if (isFullScreen()) {
    exitFullScreen(element);
  } else {
    requestFullscreen(element);
  }
}
